module.exports = __webpack_public_path__ + "img/freespin4.85d088c4.png";